// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

// --- RxJs
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

// --- 3rd Party
import { retryBackoff } from 'backoff-rxjs';
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { QuestionsBaseService } from './questions-base.service';
import { environment } from '../../../../environments/environment';
import { QuestionModel, ApplicationError } from '../../../models';
import { AppService } from '../app.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class QuestionsService extends QuestionsBaseService {
  private _questions: QuestionModel[];

  constructor(private http: HttpClient, private appService: AppService, private translate: TranslateService) {
    super();
  }

  loadQuestions(): void {
    if (this._questions && this._questions.length > 0) {
      this.initialiseQuestions(this._questions);
    }

    const url = environment.apiConfig.baseUrl + environment.apiConfig.questionsApi;

    this.http.get<QuestionModel[]>(url).pipe(

      retryBackoff(environment.retryConfig),
      catchError(this._modelError.bind(this))

    ).subscribe(questions => {

      this._questions = questions;
      this.initialiseQuestions(questions);

    });
  }

  private _modelError(err) {
    this._handleError(err);
    return of(null as QuestionModel[]);
  }

  private _handleError(err) {
    this.appService.setLoading(false);

    let error: ApplicationError;
    if (err && err instanceof HttpErrorResponse) {
      // A client-side or network error occurred. Handle it accordingly.
      let detailedMessage = `${err.message}`;
      if (err.statusText) {
        detailedMessage += `<br/>${err.statusText}`;
      }
      error = {
        errorMessage: this.translate.instant('errorMessageGenericBackend'),
        errorNumber: err.status,
        detailedMessage
      } as ApplicationError;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      error = {
        errorMessage: this.translate.instant('errorMessageGenericBackend'),
        originalError: err
      } as ApplicationError;
    }
    this.appService.setLastError(error);

    this._questions$.next(null);
  }
}
